import { render, staticRenderFns } from "./AcademyEdit.vue?vue&type=template&id=cfcd8da8&scoped=true&"
import script from "./AcademyEdit.vue?vue&type=script&lang=js&"
export * from "./AcademyEdit.vue?vue&type=script&lang=js&"
import style0 from "./AcademyEdit.vue?vue&type=style&index=0&id=cfcd8da8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd8da8",
  null
  
)

export default component.exports